export const TableHelper = {
    GetDefaultOrderedColumn
}

function GetDefaultOrderedColumn(header){
    for(const col of header){
        if(col.defaultOrdered && col.defaultOrdered){
            return col;
        }
    }
}